<template>
<div>
  <section class="content-header">
    <h1>
      订单排行
      <small>订单综合排行榜</small>
    </h1>
    <ol class="breadcrumb">
      <li><a href="#/"><i class="fa fa-dashboard"></i> Home</a></li>
      <li><a href="#/loudSpeakOperate/order">订单综合排行榜</a></li>
      <li class="active">订单排行</li>
    </ol>
  </section>

  <section class="content">
    <el-card class="box-card" body-style="padding-bottom:0px">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-select v-model="filters.customers" multiple filterable clearable placeholder="客户名称" style="width: 360px">
            <el-option
              v-for="item in customers"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
				</el-form-item>
        <el-form-item>
          <el-date-picker v-model="filters.dateRange" type="daterange" start-placeholder="开始日期"
            end-placeholder="结束日期" :picker-options="pickerOptions" :default-value="currentDate" value-format="yyyy-MM-dd">
          </el-date-picker>
				</el-form-item>
        <el-form-item v-show="$auth.check('ROLE_QOOCO')">
          <el-select v-model="filters.orgType" filterable clearable placeholder="机构类型">
            <el-option
              v-for="item in orgTypes"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
				</el-form-item>
        <el-form-item>
          <el-select v-model="filters.modeId" filterable placeholder="课程选择">
            <el-option
              v-for="item in modeList"
              :key="item.key"
              :label="item.val"
              :value="item.key">
            </el-option>
          </el-select>
        </el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="query">查询</el-button>
				</el-form-item>
			</el-form>
      <div class="duration">
        <span class="label">当前查询时间段：</span>
        <span class="value">{{dateRange[0]}} 至 {{dateRange[1]}}</span>
      </div>
    </el-card>

    <el-card class="box-card">
      <div slot="header">
        <span class="header-text">订单使用排行榜</span>
        <el-button id="exportBtn" type="primary" icon="el-icon-download" @click="exportOrders('all')">导出全部</el-button>
      </div>
      <h4 class="other" v-show="otherSchool1 && !loading1">
        <span class="school">{{otherSchool1}}</span>
        <span class="order">订单（数量）：{{otherOrder1}}</span>
      </h4>
      <div class="echart">
        <IEcharts :option="orderUseRank" :resizable="true" :loading="loading1"></IEcharts>
      </div>
      <el-pagination
        @current-change="handleCurrentChange1"
        :current-page.sync="page1"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="total1">
      </el-pagination>
    </el-card>

    <el-card class="box-card half-left">
      <div slot="header">
        <span class="header-text">MIS系统使用排行榜</span>
        <el-button id="exportBtn" type="primary" icon="el-icon-download" @click="exportOrders('mys')">导出全部</el-button>
      </div>
      <h4 class="other" v-show="otherSchool2 && !loading2">
        <span class="school">{{otherSchool2}}</span>
        <span class="order">MIS系统（充值卡数量）：{{otherOrder2}}</span>
      </h4>
      <div class="echart">
        <IEcharts :option="mysUseRank" :resizable="true" :loading="loading2"></IEcharts>
      </div>
      <el-pagination
        @current-change="handleCurrentChange2"
        :current-page.sync="page2"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="total2">
      </el-pagination>
    </el-card>
    <el-card class="box-card half-right">
      <div slot="header">
        <span class="header-text">用户使用排行榜</span>
        <el-button id="exportBtn" type="primary" icon="el-icon-download" @click="exportOrders('card')">导出全部</el-button>
      </div>
      <h4 class="other" v-show="otherSchool3 && !loading3">
        <span class="school">{{otherSchool3}}</span>
        <span class="order">用户（充值卡数量）：{{otherOrder3}}</span>
      </h4>
      <div class="echart">
        <IEcharts :option="userUseRank" :resizable="true" :loading="loading3"></IEcharts>
      </div>
      <el-pagination
        @current-change="handleCurrentChange3"
        :current-page.sync="page3"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="total3">
      </el-pagination>
    </el-card>
    <el-card class="box-card">
      <div slot="header">
        <span class="header-text">所有订单类型充值情况展示</span>
      </div>
      <div class="echart">
        <IEcharts :option="ordersSum" :resizable="true" :loading="loading5"></IEcharts>
      </div>
    </el-card>
    <el-card class="box-card">
      <div slot="header">
        <span class="header-text">订单充值具体课程信息展示</span>
      </div>
      <div class="echart">
        <IEcharts :option="modeOrders" :resizable="true" :loading="loading4"></IEcharts>
      </div>
    </el-card>
  </section>
</div>
</template>

<script>
import $ from 'jquery'
import IEcharts from 'vue-echarts-v3/src/full'
import {loadOrderUseRank, loadMysUseRank, loadUserUseRank, loadOrdersSum, loadModeOrders} from 'api/loud-speak-operate'
import {mapGetters} from 'vuex'
import {subLabel, subLabelM, getLastWeek, extractArrsFromObj, withRank, parseTwoArray, tooltipWithSum} from 'common/js/app-utils'
import {baseUrl} from 'api/base'

export default {
  computed: {
    ...mapGetters([
      'customers',
      'pickerOptions',
      'orgTypes',
      'modeList'
    ])
  },
  data () {
    return {
      // others
      otherSchool1: '',
      otherOrder1: '',
      otherSchool2: '',
      otherOrder2: '',
      otherSchool3: '',
      otherOrder3: '',
      // pagination
      page1: 1,
      page2: 1,
      page3: 1,
      total1: 0,
      total2: 0,
      total3: 0,
      pageSize: 10,

      currentDate: new Date(),
      dateRange: [],
      filters: {
        customers: [],
        dateRange: [],
        orgType: '',
        modeId: '0'
      },

      loading: true,
      loading1: true,
      loading2: true,
      loading3: true,
      loading4: true,
      loading5: true,
      orderUseRank: {
        title: {
          text: ''
        },
        tooltip: {
          trigger: 'axis'
        },
        grid: {x: '25%', y: '10%', width: '70%', height: '75%'},
        xAxis: {},
        yAxis: {
          data: [],
          axisLabel: {
            rotate: -12,
            formatter: subLabel
          }
        },
        series: [{
          name: '订单（数量）',
          type: 'bar',
          data: []
        }],
        color: ['rgb(91,155,213)']
      },
      mysUseRank: {
        title: {
          text: ''
        },
        tooltip: {
          trigger: 'axis'
        },
        grid: {x: '25%', y: '10%', width: '70%', height: '75%'},
        xAxis: {},
        yAxis: {
          data: [],
          axisLabel: {
            rotate: -42,
            formatter: subLabelM
          }
        },
        series: [{
          name: 'Mys系统（充值卡数量）',
          type: 'bar',
          data: []
        }],
        color: ['rgb(91,155,213)']
      },
      userUseRank: {
        title: {
          text: ''
        },
        tooltip: {
          trigger: 'axis'
        },
        grid: {x: '25%', y: '10%', width: '70%', height: '75%'},
        xAxis: {},
        yAxis: {
          data: [],
          axisLabel: {
            rotate: -42,
            formatter: subLabelM
          }
        },
        series: [{
          name: '用户（数量）',
          type: 'bar',
          data: []
        }],
        color: ['rgb(91,155,213)']
      },
      ordersSum: {
        title: {
          text: ''
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: tooltipWithSum
        },
        grid: {x: '13%', y: '14%', width: '70%', height: '75%'},
        xAxis: {
          type: 'category',
          data: []
        },
        yAxis: {
          type: 'value'
        },
        legend: {
          orient: 'vertical',
          top: '30%',
          left: 'right',
          data: ['充值卡充值', 'Mys系统充值']
        },
        series: [{
          name: 'Mys系统充值',
          type: 'bar',
          stack: '总量',
          itemStyle: {normal: {label: {show: true, position: 'inside'}}},
          data: [],
          color: ['rgb(255,192,0)']
        }, {
          name: '充值卡充值',
          type: 'bar',
          stack: '总量',
          itemStyle: {normal: {label: {show: true, position: 'inside'}}},
          data: [],
          color: ['rgb(237,125,49)']
        }]
      },
      modeOrders: {
        title: {
          text: ''
        },
        tooltip: {
          trigger: 'axis'
        },
        grid: {x: '13%', y: '14%', width: '70%', height: '75%'},
        xAxis: {
          type: 'category',
          data: []
        },
        yAxis: {
          type: 'value'
        },
        legend: {
          orient: 'vertical',
          top: '30%',
          left: 'right',
          data: ['两年卡', '年卡', '半年卡', '季卡', '两月卡', '月卡（包括≤31天的充值）', '折合为月卡', '其他']
        },
        series: [{
          name: '两年卡',
          type: 'bar',
          data: []
        }, {
          name: '年卡',
          type: 'bar',
          data: []
        }, {
          name: '半年卡',
          type: 'bar',
          data: []
        }, {
          name: '季卡',
          type: 'bar',
          data: []
        }, {
          name: '两月卡',
          type: 'bar',
          data: []
        }, {
          name: '月卡（包括≤31天的充值）',
          type: 'bar',
          data: []
        }, {
          name: '折合为月卡',
          type: 'bar',
          data: []
        }, {
          name: '其他',
          type: 'bar',
          data: []
        }]
        // color: ['rgb(255,192,0)', 'rgb(237,125,49)', 'rgba(222, 66, 67, 1)', 'rgba(53, 74, 95, 1)', 'rgba(101, 154, 42, 1)']
      }
    }
  },
  components: {
    IEcharts
  },
  mounted () {
    this.query()
  },
  methods: {
    exportOrders (type_) {
      let form = $('<form>')
      form.attr('style', 'display:none')
      form.attr('target', '')
      form.attr('method', 'post')
      form.attr('action', baseUrl + `exports/orders/${type_}`)
      let input = $('<input>')
      input.attr('type', 'hidden')
      input.attr('name', 'token')
      input.attr('value', localStorage.getItem('default_auth_token'))
      $('body').append(form)
      form.append(input)
      form.submit()
    },
    handleCurrentChange1 (val) {
      this._loadOrderUseRank(val, this.pageSize)
    },
    handleCurrentChange2 (val) {
      this._loadMysUseRank(val, this.pageSize)
    },
    handleCurrentChange3 (val) {
      this._loadUserUseRank(val, this.pageSize)
    },
    query () {
      this._showDateRange()
      this._loadOrderUseRank(1, this.pageSize)
      this._loadMysUseRank(1, this.pageSize)
      this._loadUserUseRank(1, this.pageSize)
      this._loadOrdersSum()
      this._loadModeOrders()
    },
    _showDateRange () {
      let t = this.filters.dateRange
      if (t && t.length === 2) {
        this.dateRange = t
      } else {
        this.dateRange = getLastWeek()
      }
    },
    _loadOrderUseRank (page, pageSize) {
      this.loading1 = true
      loadOrderUseRank(page, pageSize, this.filters)
      .then((res) => {
        this.loading1 = false
        let arrs = extractArrsFromObj(res.rows, ['school', 'num', 'rank'])
        let schoolWithRank = withRank(arrs.school, arrs.rank)
        this.orderUseRank.yAxis.data = schoolWithRank
        this.orderUseRank.series[0].data = arrs.num
        this.total1 = res.total
        let other = res.others
        if (other && (this.orgType === 'all' || !this.orgType)) {
          this.otherSchool1 = other.school + ' [' + other.rank + ']'
          this.otherOrder1 = other.num
        } else if (this.page1 === 1) {
          this.otherSchool1 = ''
        }
      }, (msg) => {
        this.loading1 = false
        this.orderUseRank.yAxis.data = ''
        this.orderUseRank.series[0].data = ''
        this.total1 = ''
        this.$message.error(msg)
      })
    },
    _loadMysUseRank (page, pageSize) {
      this.loading2 = true
      loadMysUseRank(page, pageSize, this.filters)
      .then((res) => {
        this.loading2 = false
        let arrs = extractArrsFromObj(res.rows, ['school', 'num', 'rank'])
        let schoolWithRank = withRank(arrs.school, arrs.rank)
        this.mysUseRank.yAxis.data = schoolWithRank
        this.mysUseRank.series[0].data = arrs.num
        this.total2 = res.total
        let other = res.others
        if (other && (this.orgType === 'all' || !this.orgType)) {
          this.otherSchool2 = other.school + ' [' + other.rank + ']'
          this.otherOrder2 = other.num
        } else if (this.page2 === 1) {
          this.otherSchool2 = ''
        }
      }, (msg) => {
        this.loading2 = false
        this.mysUseRank.yAxis.data = ''
        this.mysUseRank.series[0].data = ''
        this.total2 = ''
        this.otherSchool2 = ''
        this.$message.error(msg)
      })
    },
    _loadUserUseRank (page, pageSize) {
      this.loading3 = true
      loadUserUseRank(page, pageSize, this.filters)
      .then((res) => {
        this.loading3 = false
        let arrs = extractArrsFromObj(res.rows, ['school', 'num', 'rank'])
        let schoolWithRank = withRank(arrs.school, arrs.rank)
        this.userUseRank.yAxis.data = schoolWithRank
        this.userUseRank.series[0].data = arrs.num
        this.total3 = res.total
        let other = res.others
        if (other && (this.orgType === 'all' || !this.orgType)) {
          this.otherSchool3 = other.school + ' [' + other.rank + ']'
          this.otherOrder3 = other.num
        } else if (this.page3 === 1) {
          this.otherSchool3 = ''
        }
      }, (msg) => {
        this.loading3 = false
        this.userUseRank.yAxis.data = ''
        this.userUseRank.series[0].data = ''
        this.total3 = ''
        this.otherSchool3 = ''
        this.$message.error(msg)
      })
    },
    _loadOrdersSum () {
      this.loading5 = true
      loadOrdersSum(this.filters)
      .then((res) => {
        console.log(res)
        this.loading5 = false
        let _res = {}
        res.forEach(obj => {
          if (obj.from_mys === 'true') {
            _res.fromMys = obj.data
          } else {
            _res.notFromMys = obj.data
          }
        })
        console.log(_res)
        let fromMys = this._parseAllCardUse(_res.fromMys)
        let notFromMys = this._parseAllCardUse(_res.notFromMys)
        console.log(fromMys)
        this.ordersSum.xAxis.data = fromMys.keys
        this.ordersSum.series[0].data = fromMys.values
        this.ordersSum.series[1].data = notFromMys.values
      }, (msg) => {
        this.loading5 = false
        this.$message.error(msg)
      })
    },
    _loadModeOrders () {
      this.loading4 = true
      loadModeOrders(this.filters)
      .then((res) => {
        this.loading4 = false
        let arrs = extractArrsFromObj(res, ['mode_name', 'data'])
        let dataArrs = extractArrsFromObj(arrs.data, ['month_1', 'month_2', 'month_3', 'month_6', 'month_12', 'month_24', 'month_13', 'convert_month_1'])
        this.modeOrders.xAxis.data = arrs.mode_name
        this.modeOrders.series[0].data = dataArrs.month_24
        this.modeOrders.series[1].data = dataArrs.month_12
        this.modeOrders.series[2].data = dataArrs.month_6
        this.modeOrders.series[3].data = dataArrs.month_3
        this.modeOrders.series[4].data = dataArrs.month_2
        this.modeOrders.series[5].data = dataArrs.month_1
        this.modeOrders.series[6].data = dataArrs.convert_month_1
        this.modeOrders.series[7].data = dataArrs.month_13
      }, (msg) => {
        this.loading4 = false
        this.$message.error(msg)
      })
    },
    _parseAllCardUse (obj) {
      if (!obj) { // 兼容API返回格式错误
        obj = {
          month_24: 0,
          month_12: 0,
          month_6: 0,
          month_3: 0,
          month_2: 0,
          month_1: 0,
          convert_month_1: 0,
          month_13: 0
        }
      }
      let map = new Map()
      map.set('month_24', '两年卡')
      map.set('month_12', '年卡')
      map.set('month_6', '半年卡')
      map.set('month_3', '季卡')
      map.set('month_2', '两月卡')
      map.set('month_1', '月卡')
      map.set('convert_month_1', '折合为月卡张数')
      map.set('month_13', '其他')
      return parseTwoArray(obj, map)
    }
  }
}
</script>

<style lang="stylus" scoped>
  @import '~common/stylus/base'
  .other
    border-radius: 5px
    padding: 5px 10px
    background: #f39c12
    border-color: #f39c12
    color: #fff
    .school
      margin-left:20px
    .order
      margin-left:30px
</style>



// WEBPACK FOOTER //
// src/components/loud-speak-operate/order.vue